import React from 'react';
import ReactDOM from 'react-dom';
import CookiePolicy from './cookie-policy';

/**
 * entry point
 */
export const init = () => {
    const $root = document.getElementById('react-app-cookies-policy');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <CookiePolicy />
        </React.StrictMode>,
        $root
    );
};

init();